<div class="conversations-container">
  <h1 class="page-title" i18n="@@conversations.title">Call History</h1>

  <p-tabs [value]="activeTab()" (valueChange)="onTabChange($any($event))" styleClass="conv-tabs">
    <p-tablist>
      <p-tab value="sessions" i18n="@@conversations.tab.sessions">Sessions</p-tab>
      <p-tab value="calls" i18n="@@conversations.tab.calls">Calls</p-tab>
    </p-tablist>
  </p-tabs>

  <router-outlet />
</div>
